
import styled from "styled-components";

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {useState,Fragment} from "react";
import Collapse from '@mui/material/Collapse';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { estadoCuenta} from "../../../redux/actions/cuentasActions.js";
import api from '../../../axios.js';
import { useDispatch } from 'react-redux'
import Card from "../../juegos/card.jsx"


const NoGames=styled.div`
	font-size:25px
`;


export default function RowTableCuentas(props) {
  const { row ,isItemSelected,handleClick, labelId,setAddGame} = props;
  const [open, setOpen] =useState(false);
  let dispatch=useDispatch();



let addgame=async(id)=>{
	setAddGame({id:id,status:true})
}
let deleteGame=async(juego)=>{
	if(window.confirm(`Desea eliminar el juego ${juego.nombre} de ${juego.consola}`)){
		dispatch(estadoCuenta(1));
		try{
			let rsp = await api.delete(`/cuenta/deleteGame?id=${juego.id}`);
			alert (rsp.data);
		}catch(err){console.log(err);alert("error al grabar los datos")}
		dispatch(estadoCuenta(0));
	}
}

  return(
  		<Fragment>
            <TableRow   hover role="checkbox" aria-checked={isItemSelected} tabIndex={-1} key={row.id} selected={isItemSelected} sx={{ cursor: 'pointer' }}>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                         onClick={(event) => handleClick(event, row.id)}
                        checked={isItemSelected}
                        inputProps={{
                          'aria-labelledby': labelId,
                        }}
                      />
                    </TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.id}</TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.correo}</TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.playstationId}</TableCell>
                    <TableCell  sx={{fontSize:"12px"}}>{row.creacion}</TableCell>
                    <TableCell align="center" >
                    	<IconButton  size="small" onClick={()=>addgame(row.id)} >
            				 		<AddIcon sx={{color:"#21D014"}} /> 
          						</IconButton>
        						</TableCell>
                    <TableCell align="right">
                    	<IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)} >
            				{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          				</IconButton>
        			</TableCell>
            </TableRow>
             <TableRow sx={{ cursor: 'pointer'}} >
        			<TableCell sx={{ paddingBottom: open?"55px":0, paddingTop: open?"55px":0, width:"100%"}} colSpan={6}>
			          <Collapse in={open} timeout="auto" unmountOnExit>
			            <Box sx={{ margin: 1, display: 'flex', justifyContent: 'flex-end',width:"100%",flexDirection:"column", p: 1 }}>
			              <Typography variant="h6" gutterBottom component="div">
			                {`Juegos de  ${row.correo}`} 
			              </Typography>
			              {row.juegos.length>0?
			              <Table size="small" aria-label="purchases" sx={{width:"100%" }}>
			                <TableHead>
			                  <TableRow>
			                  	<TableCell  align="right" ></TableCell>
			                    <TableCell  align="right" >nombre</TableCell>
			                    <TableCell  align="right" >consola</TableCell>
			                    <TableCell  align="right" >fecha ingreso a playland™</TableCell>
			                    
			                    <TableCell  align="right" >delete</TableCell>
			                  </TableRow>
			                </TableHead>
			                <TableBody>
			                  {row.juegos.map((juegoRow) => (
			                    	<TableRow key={juegoRow.id} >
			                    			<TableCell  align="right" >
			                    				<div style={{width:"60px",height:"70px"}}>
			                    					<Card  consola={juegoRow.consola}poster={juegoRow.poster}/>
			                    				</div>
			                    			</TableCell>
			                    			<TableCell  align="right" >{juegoRow.nombre}</TableCell>
			                      		<TableCell  align="right"  component="th" scope="row">{juegoRow.consola}</TableCell>
			                      		<TableCell  align="right" >{juegoRow.fechaAdquisicion}</TableCell>
			                      		
			                      		<TableCell align="right"><RemoveIcon onClick={()=>deleteGame(juegoRow)} size="small" sx={{color:"red"}} /></TableCell>
			                    	</TableRow>
			                  	))}
			                </TableBody>
			              </Table>:<NoGames>Sin juegos asignados</NoGames>
			            }

			            </Box>
			          </Collapse>
			        </TableCell>
			      </TableRow>
                	
		 </Fragment>




  	)}